export const LOAD_ENTITIES_PREFIX = 'LOAD_ENTITIES';
export const LOAD_ENTITIES_REQUEST = `${LOAD_ENTITIES_PREFIX}_REQUEST`;
export const LOAD_ENTITIES_SUCCESS = `${LOAD_ENTITIES_PREFIX}_SUCCESS`;
export const LOAD_ENTITIES_ERROR = `${LOAD_ENTITIES_PREFIX}_ERROR`;
export const LOAD_ENTITIES_ERROR_MESSAGE = 'Error loading robot models';

export const loadEntitiesRequest = () => ({
  type: LOAD_ENTITIES_REQUEST,
});
